import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectIsHrefFollowable } from 'src/redux/content/selectors/selectIsHrefFollowable';
import { selectResolvedPathname } from 'src/redux/navigation/selectors';

/**
 * Whether the current URL is indexable — the {@link selectIsHrefFollowable}
 * predicate applied to the current pathname. Only an exact match against an
 * indexable entry counts: a long-tail filter combination that merely borrows an
 * ancestor's content is not itself indexable.
 *
 * The page is just another subject of the one followability rule, so the page's
 * meta robots tag ({@link selectTaxonomyRobotsContent}) and a link's crawlability
 * ({@link selectIsHrefFollowable}) are governed by the same signal and cannot
 * drift.
 */
export const selectIsCurrentUrlIndexable = (state: ReduxApplicationState): boolean =>
  selectIsHrefFollowable(state)(selectResolvedPathname(state));
